export const LOAD_LOGIN_INFO = 'LOAD_LOGIN_INFO'
export const SAVE_LOGIN_INFO = 'SAVE_LOGIN_INFO'
export const SAVE_GOINGTOURL = 'SAVE_GOINGTOURL'
